export default __webpack_public_path__ + "static/media/pen-fill.9a8950f1.svg";